import React from 'react';
import styled from 'styled-components';
import withPaymentV2 from '@catalogo/service-americanas-product/src/hocs/payment-v2';
import DiscountProgressive from '@catalogo/ui-americanas-mobile-discount-progressive';
import { PaymentConditionText } from './components/payment-condition-text';
import { BestPrice } from './components/best-price';
import { PaymentInstallmentText } from './components/payment-installment-text';
import { MorePaymentMethods } from './components/more-payment-methods';
import { AmeBox } from './components/ame-box';
import { PriceText } from './styles';

export const Buybox = ({
  defaultPriceText,
  buyTogetherPriceText,
  mainPayment,
  international,
  discountProgressive,
  isNurslingProduct,
}) => {
  if (!mainPayment) {
    return (
      <Wrapper>
        <BestPrice defaultPriceText={defaultPriceText} />
      </Wrapper>
    );
  }

  if (buyTogetherPriceText) {
    return (
      <Wrapper>
        <PriceText>{buyTogetherPriceText}</PriceText>
        <span>com item sugerido</span>
      </Wrapper>
    );
  }

  const { paymentInstallmentText } = mainPayment;

  return (
    <Wrapper>
      <BestPrice international={international} payment={mainPayment} isNurslingProduct={isNurslingProduct} />
      <PaymentConditionText payment={mainPayment} />
      {paymentInstallmentText && <PaymentInstallmentText text={paymentInstallmentText} />}
      <MorePaymentMethods />
      <DiscountProgressive
        quantityForDiscount={discountProgressive?.quantityForDiscount}
        priceUnit={discountProgressive?.priceUnit}
      />
      <AmeBox cashback={mainPayment?.cashback} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  padding: 30px 0px 24px;
  font-size: 14px;

  @media (max-width: 768px) {
    padding: 0px 16px 14px 16px;
  }
`;

export default withPaymentV2(Buybox);
